// todo move this file to module
export let sendSmsAfterTwoStepLogin = {
    '1': 'فعال',
    '0': 'غیرفعال',
}